import { get } from 'lodash';

import { FIELD_PATHS, FIELD_VALUES, LIABILITY_TYPE } from '@funnels/constants';
import { AnyFormValues } from '@funnels/types';

export const getLiabilityBalanceForRepayment = (liabilityIndex: number, formValues: AnyFormValues) => {
  const liabilityType = get(formValues, FIELD_PATHS.LIABILITY_TYPE(liabilityIndex));
  const repaymentType = get(formValues, FIELD_PATHS.LIABILITY_REPAYMENT_TYPE(liabilityIndex));

  // To have a more accurate calculation where customers are ahead in their repayment
  // and balance != limit, limit is used instead of balance for P&I HOME LOAN
  const shouldUseLimitForCalculation =
    liabilityType === LIABILITY_TYPE.HOME_LOAN && repaymentType === FIELD_VALUES.PRINCIPAL_AND_INTEREST;

  const outstandingBalance = get(formValues, FIELD_PATHS.LIABILITY_OUTSTANDING_BALANCE(liabilityIndex));
  const limit = get(formValues, FIELD_PATHS.LIABILITY_CREDIT_LIMIT(liabilityIndex));
  const balance = (shouldUseLimitForCalculation ? limit : outstandingBalance) || outstandingBalance;

  return balance;
};
